<template>
    <div>
        <Cafe24OrderList/>
    </div>
</template>

<script>
    import Cafe24OrderList from '@/components/cafe24/Cafe24OrderList';

    export default {
        name: 'Cafe24OrderListView',
        components: {Cafe24OrderList},
    };
</script>

<style lang="scss" scoped>

</style>